import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BilanPtaComponent } from './edition/bilan-pta/bilan-pta.component';
import { BudgetByProgrammeComponent } from './edition/budget-by-programme/budget-by-programme.component';
import { GraphiqueComponent } from './edition/graphique/graphique.component';
import { IndicateurCleComponent } from './edition/indicateur-cle/indicateur-cle.component';
import { RapportPerformanceComponent } from './edition/rapport-performance/rapport-performance.component';
import { TableaudBordIndicateurComponent } from './edition/tableaud-bord-indicateur/tableaud-bord-indicateur.component';
import { TableaudBordProjetComponent } from './edition/tableaud-bord-projet/tableaud-bord-projet.component';
import { TauxExecutionComponent } from './edition/taux-execution/taux-execution.component';
import { TepActivitesComponent } from './edition/tep-activites/tep-activites.component';
import { TepGlobalObgrmComponent } from './edition/tep-global-obgrm/tep-global-obgrm.component';
import { TepProjetComponent } from './edition/tep-projet/tep-projet.component';
import { TepSousActivitesComponent } from './edition/tep-sous-activites/tep-sous-activites.component';
import { ActiviteHorsPtaComponent } from './execution/activite-hors-pta/activite-hors-pta.component';
import { CartographieComponent } from './execution/cartographie/cartographie.component';
import { DecaissemntComponent } from './execution/decaissemnt/decaissemnt.component';
import { EngagementComponent } from './execution/engagements/engagement/engagement.component';
import { OrdonnancementComponent } from './execution/ordonnancements/ordonnancement/ordonnancement.component';
import { RealisationIndicateursComponent } from './execution/realisation-indicateurs/realisation-indicateurs.component';
import { TacheComponent } from './execution/taches/tache/tache.component';
import { ActionComponent } from './plananalytique/actions/action/action.component';
import { DirectionComponent } from './plananalytique/directions/direction/direction.component';
import { GestionAccesComponent } from './plananalytique/gestion/gestion-acces/gestion-acces.component';
import { IndicateurComponent } from './plananalytique/indicateurs/indicateur/indicateur.component';
import { PlanificationComponent } from './plananalytique/indicateurs/planification/planification.component';
import { DetailProjetIndicateurComponent } from './plananalytique/programme/detail-projet-indicateur/detail-projet-indicateur.component';
import { ProjetIndicateurComponent } from './plananalytique/programme/projet-indicateur/projet-indicateur.component';
import { ProjetdirectionComponent } from './plananalytique/projetdirection/projetdirection.component';
import { ServiceComponent } from './plananalytique/services/service/service.component';
import { AddProjetToActiviteComponent } from './planification/add-projet-to-activite/add-projet-to-activite.component';
import { AddSousActivitToActiviteComponent } from './planification/add-sous-activit-to-activite/add-sous-activit-to-activite.component';
import { AddTacheSousActiviteComponent } from './planification/add-tache-sous-activite/add-tache-sous-activite.component';
import { CibleIndicateursComponent } from './planification/cible-indicateurs/cible-indicateurs.component';
import { ImportationPtaComponent } from './planification/importation-pta/importation-pta.component';
import { RevueBudgetaireComponent } from './planification/revue-budgetaire/revue-budgetaire.component';
import { ValidationPtaComponent } from './planification/validation/validation-pta/validation-pta.component';
import { RecommandationExecutionComponent } from './execution/recommandation-execution/recommandation-execution.component';
import { PtaGlobalComponent } from './edition/pta-global/pta-global.component';
import { PtaServiceComponent } from './edition/pta-service/pta-service.component';
import { TepPdcComponent } from './edition/tep-pdc/tep-pdc.component';
import { PaiComponent } from './edition/pai/pai.component';
import { EvaluationPtaComponent } from './edition/evaluation-pta/evaluation-pta.component';
import { RecommandationComponent } from './planification/recommandation/recommandation.component';
import { TraitementRecommendationComponent } from './execution/traitement-recommendation/traitement-recommendation.component';
import { MissionComponent } from './planification/mission/mission.component';
import { TepDirectionComponent } from './edition/tep-direction/tep-direction.component';
import { PtaByPeriodeComponent } from './planification/pta-by-periode/pta-by-periode.component';
import { IndicateurPerformanceComponent } from './plananalytique/indicateur-performance/indicateur-performance/indicateur-performance.component';
import { IndicateurObjectifComponent } from './plananalytique/indicateur-objectif/indicateur-objectif/indicateur-objectif.component';
import { ListingPdcComponent } from '../pdc/listing-pdc/listing-pdc.component';
import { ResultatsComponent } from './plananalytique/resultats/resultats.component';
import { ObjectifSpecifiqueComponent } from './plananalytique/objectif-specifique/objectif-specifique.component';
import { TepPaiComponent } from './edition/pai/tep-pai/tep-pai.component';
import { StatsPaiComponent } from './edition/pai/stats-pai/stats-pai.component';
import { ChapitreComponent } from './recettes/chapitre/chapitre.component';
import { SousChapitreComponent } from './recettes/sous-chapitre/sous-chapitre.component';
import { CompteBudgetaireComponent } from './recettes/compte-budgetaire/compte-budgetaire.component';
import { PrevisionComponent } from './recettes/prevision/prevision.component';
import { TitresComponent } from './recettes/titres/titres.component';
import { RecouvrementComponent } from './recettes/recouvrement/recouvrement.component';

const routes: Routes = [


  { path: 'tableaux-de-bord', component: DashboardComponent },
  // plan
  // {
  //   path: 'plan/programme',
  //   component: ProgrammeComponent
  // },

  {
    path: 'plan/action',
    component: ActionComponent
  },
  {
    path: 'plan/projet-lien-indicateur',
    component: ProjetIndicateurComponent
  },

  {
    path: 'plan/indicateur',
    component: IndicateurComponent
  },
  {
    path: 'plan/planification-indicateur',
    component: PlanificationComponent
  },

  {
    path: 'plan/detail-projet',
    component: DetailProjetIndicateurComponent
  },

  {
    path: 'plan/direction',
    component: DirectionComponent
  },
  {
    path: 'plan/projet-direction',
    component: ProjetdirectionComponent
  },
  {
    path: 'plan/programmes',
    // component: ProgrammeComponent
    component: ProjetIndicateurComponent
  },

  {
    path: 'plan/service',
    component: ServiceComponent
  },

  {
    path: 'plan/gestion-acces',
    component: GestionAccesComponent
  },

  {
    path: 'plan/indicateur-resultat',
    component: IndicateurComponent
  },

  {
    path: 'plan/indicateur-performance',
    component: IndicateurPerformanceComponent
  },

  {
    path: 'plan/indicateur-objectif',
    component: IndicateurObjectifComponent
  },

  {
    path: 'plan/projets-pdc',
    component: ListingPdcComponent
  },

   {
    path: 'plan/resultat',
    component: ResultatsComponent
  },

    {
    path: 'plan/objectif-specifique',
    component: ObjectifSpecifiqueComponent
  },
  //end

  //palinificatiion

  {
    path: 'planification/importation',
    component: ImportationPtaComponent
  },

  {
    path: 'planification/validation',
    component: ValidationPtaComponent
  },

  {
    path: 'planification/projet-activite',
    component: AddProjetToActiviteComponent
  },


  {
    path: 'planification/activite-sous-activite',
    component: AddSousActivitToActiviteComponent
  },

  {
    path: 'planification/sous-activite-tache',
    component: AddTacheSousActiviteComponent
  },

  {
    path: 'planification/budgetaire',
    component: RevueBudgetaireComponent
  },

  {
    path: 'planification/cible-indicateurs',
    component: CibleIndicateursComponent
  },

  {
    path: 'planification/activite-hors-pta',
    component: ActiviteHorsPtaComponent
  },

  // {
  //   path: 'planification/mission',
  //   component: MissionComponent
  // },
  {
    path: 'planification/recommandation',
    component: MissionComponent
  },

  {
    path: 'planification/pta-par-periode',
    component: PtaByPeriodeComponent
  },
  //end
  //execution

  {
    path: 'execution/tâche',
    component: TacheComponent
  },
  {
    path: 'execution/cartographie',
    component: CartographieComponent
  },

  {
    path: 'execution/realisation',
    component: RealisationIndicateursComponent
  },

  {
    path: 'execution/engagement',
    component: EngagementComponent
  },

  {
    path: 'execution/ordonnancement',
    component: OrdonnancementComponent
  },


  {
    path: 'execution/decaissemnt',
    component: DecaissemntComponent
  },

  {
    path: 'execution/activite-hors-pta',
    component: ActiviteHorsPtaComponent
  },
  {
    path: 'execution/recommandation',
    component: RecommandationExecutionComponent
  },
  {
    path: 'execution/traitement-recommandation/:id',
    component: TraitementRecommendationComponent
  },

  {
    path: 'recettes/bordereau-recettes',
    redirectTo: 'recettes/bordereau-recettes/chapitre',
    pathMatch: 'full'
  },
  {
    path: 'recettes/bordereau-recettes/chapitre',
    component: ChapitreComponent
  },
  {
    path: 'recettes/bordereau-recettes/sous-chapitre',
    component: SousChapitreComponent
  },
  {
    path: 'recettes/bordereau-recettes/compte-budgetaire',
    component: CompteBudgetaireComponent
  },
  {
    path: 'recettes/bordereau-recettes/prevision',
    component: PrevisionComponent
  },
  {
    path: 'recettes/bordereau-recettes/titres',
    component: TitresComponent
  },
  {
    path: 'recettes/bordereau-recettes/recouvrement',
    component: RecouvrementComponent
  },

  //debut edition

  {
    path: 'edition/tache',
    component: TacheComponent
  },
  {
    path: 'edition/tep-activite',
    component: TepActivitesComponent
  },
  {
    path: 'edition/tep-sous-activite',
    component: TepSousActivitesComponent
  },

  {
    path: 'edition/tep-projet',
    component: TepProjetComponent
  },

  {
    path: 'edition/tep-direction',
    component: TepDirectionComponent
  },



  {
    path: 'edition/tep-global-obgrm',
    component: TepGlobalObgrmComponent
  },

  {
    path: 'edition/tableaubord',
    component: TableaudBordProjetComponent
  },
  {
    path: 'edition/tableaubord-indicateur',
    component: TableaudBordIndicateurComponent
  },

  {
    path: 'edition/bilan',
    component: BilanPtaComponent
  },

  {
    path: 'edition/tep-by-projet',
    component: RapportPerformanceComponent
  },

  {
    path: 'edition/graphique',
    component: GraphiqueComponent
  },
  {
    path: 'edition/taux-execution',
    component: TauxExecutionComponent
  },
  {
    path: 'edition/indicateur-cle',
    component: IndicateurCleComponent
  },

  {
    path: 'edition/budget-by-programme',
    component: BudgetByProgrammeComponent
  },


  // {
  //   path: 'edition/pta-global',
  //   component: PtaGlobalComponent
  // },

  {
    path: 'edition/pta-service',
    component: PtaServiceComponent
  },
  {
    path: 'edition/pdc',
    component: TepPdcComponent
  },
  {
    path: 'edition/pai',
    component: PaiComponent
  },

   {
    path: 'edition/tep-pai',
    component: TepPaiComponent
  },

  {
    path: 'edition/pai-stats',
    component: StatsPaiComponent
    
  },
  {
    path: 'edition/evaluation-pta',
    component: EvaluationPtaComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SuiviRoutingModule { }
